var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-empty',{attrs:{"image":"error","description":"抱歉，您暂无权限访问"}})}
var staticRenderFns = []

export { render, staticRenderFns }